import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/report_day";
import validateForm from "../../lib/helpers/validateForm";

// UI
import {
  Alerts,
  Button,
  HeaderPage,
  Table,
  P,
  Input,
  ButtonGroup
} from "../../ui";

class ReportDayEditPage extends Component {
  state = {
    titleHeader: "Изменение отчёта за день",
    report: {},
    filials: {},
    headers: {
      day: [
        { title: "Филиала", prefix: "название" },
        { title: "начало дня", prefix: "Касса на" },
        { title: "конец дня", prefix: "Касса на" }
      ]
    },
    buttons: {
      save: {
        disabled: false,
        title: "Изменить отчёт"
      }
    }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;
    const reportData = await API.reports.getOneById(id);

    if (reportData) {
      const report = { ...reportData };
      const filials = {};

      // Заполняем форму
      for (let filial of reportData.filials) {
        filials[filial._id] = {
          _id: filial.filial_id._id,
          name: filial.filial_id.name,
          form: {
            cash_desk: {
              value: filial.cash_desk,
              isEdited: false,
              isNumber: true,
              isError: false,
              errors: [],
              validate: Model.cash_desk
            },
            cash_desk_start_day: {
              value: filial.cash_desk_start_day,
              isEdited: false,
              isNumber: true,
              isError: false,
              errors: [],
              validate: Model.cash_desk_start_day
            }
          }
        };
      }

      this.setState({ report, filials });
    }
  }

  handleInput = e => {
    let value = e.target.value;
    let [filialReportId, name] = String(e.target.name).split(":");
    const { filials } = this.state;

    console.log("handleInput:", filialReportId, name);
    console.log(filials[filialReportId], filials[filialReportId].form[name]);

    if (
      filialReportId &&
      filials[filialReportId] &&
      filials[filialReportId].form[name]
    ) {
      if (filials[filialReportId].form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          filials: {
            ...prevState.filials,
            [filialReportId]: {
              ...prevState.filials[filialReportId],
              form: {
                ...prevState.filials[filialReportId].form,
                [name]: {
                  ...prevState.filials[filialReportId].form[name],
                  value,
                  isEdited: true,
                  isError: false,
                  errors: []
                }
              }
            }
          }
        };
      });
    }
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    let isValidFull = true;
    const filialsValidate = this.state.filials;

    for (let filialReportId in filialsValidate) {
      const result = validateForm(this.state.filials[filialReportId].form);

      if (!result.valid) {
        isValidFull = false;
      }

      filialsValidate[filialReportId].form = result.form;
    }

    this.setState({
      filials: filialsValidate
    });

    // Success
    if (isValidFull) {
      const { filials } = this.state;
      const optionsRequest = {};

      for (let filialReportId in filials) {
        for (let nameItem in filials[filialReportId].form) {
          if (filials[filialReportId].form[nameItem].isEdited) {
            if (!optionsRequest[filialReportId]) {
              optionsRequest[filialReportId] = {};
            }

            optionsRequest[filialReportId][nameItem] =
              filials[filialReportId].form[nameItem].value;
          }
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        // Изменение текущего
        const reportId = this.props.match.params.id;
        const resultUpdated = await API.reports.editOne(reportId, {
          filials: { ...optionsRequest }
        });

        if (resultUpdated) {
          Alerts.success("Отчёт изменён");

          this.props.history.goBack();
        } else {
          Alerts.error("Отчёт не изменён");
        }
      } else {
        Alerts.info("В отчёте нет изменений");

        this.props.history.goBack();
      }
    }
  };

  render() {
    const { filials } = this.state;
    const filialsList = [];

    for (let filialReportId in filials) {
      filialsList.push(
        <tr key={`filial-value-${filialReportId}`}>
          <td>
            <P margin="no">{filials[filialReportId].name}</P>
          </td>
          <td>
            <Input
              name={`${filialReportId}:cash_desk_start_day`}
              type="number"
              value={filials[filialReportId].form.cash_desk_start_day.value}
              errors={filials[filialReportId].form.cash_desk_start_day.errors}
              handleChange={this.handleInput}
            />
          </td>
          <td>
            <Input
              name={`${filialReportId}:cash_desk`}
              type="number"
              value={filials[filialReportId].form.cash_desk.value}
              errors={filials[filialReportId].form.cash_desk.errors}
              handleChange={this.handleInput}
            />
          </td>
        </tr>
      );
    }
    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <form className="form" onSubmit={this.handleFormSubmit}>
          <HeaderPage
            title={this.state.titleHeader}
            // subTitle={getDateFormat(this.state.report.date)}
            back={this.props.history.goBack}
          >
            <ButtonGroup>
              <Button
                type="submit"
                theme="success"
                disabled={this.state.buttons.save.disabled}
              >
                {this.state.buttons.save.title}
              </Button>
              <Button
                type="button"
                onClick={() => this.props.history.goBack()}
                theme="default"
              >
                Отмена
              </Button>
            </ButtonGroup>
          </HeaderPage>

          <Table headers={this.state.headers.day}>{filialsList}</Table>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(ReportDayEditPage));
